import { render, staticRenderFns } from "./orderReviewKanBan.vue?vue&type=template&id=a05d0362&"
import script from "./orderReviewKanBan.vue?vue&type=script&lang=js&"
export * from "./orderReviewKanBan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports